export default class {
  constructor(el, options) {
    const scrollEvent = window.addEventListener(
      "scroll",
      () => {
        window.requestAnimationFrame(() => {
          el.style.opacity = 1 - window.scrollY / 100
          el.style.transform = `translateY(${window.scrollY / 2}px)`
        })

        if (window.scrollY > window.innerHeight) {
          window.removeEventListener("scroll", scrollEvent)
          el.style.opacity = 1
          el.style.transform = "translateY(0)"
        }
      },
      {
        passive: true,
      },
    )
  }
}
